import { DataTable } from '../../components/data-table.tsx';
import { formatDateTime } from '../../components/format.ts';
import { Loaded } from '../../components/page.tsx';
import { useTenantQuery } from '../../data/console-context.tsx';
import type { ConsoleData, TenantSummary } from '../../data/console-data.ts';

const loadEvents = (data: ConsoleData, tenant: TenantSummary) => data.listAuditEvents(tenant.id);

export function ActivityPage() {
  const events = useTenantQuery(loadEvents);
  return (
    <Loaded query={events}>
      {(rows) => (
        <>
          <DataTable
            caption="Changes"
            columns={[
              { header: 'When', cell: (row) => formatDateTime(row.at) },
              { header: 'Who', cell: (row) => row.actor },
              { header: 'Change', cell: (row) => <code>{row.event}</code> },
              { header: 'Details', cell: (row) => describeDetails(row.details) },
            ]}
            rows={rows}
          />
          {rows.length === 0 && <p className="muted">Nothing has changed yet.</p>}
        </>
      )}
    </Loaded>
  );
}

function describeDetails(details: Readonly<Record<string, unknown>>): string {
  return Object.entries(details)
    .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : String(value)}`)
    .join('; ');
}
